import {gql} from '@apollo/client';

export const MUTATION_DELETE_ACCOUNT = gql`
mutation createDeleteAccount($data: DeleteAccountInput!) {
    createDeleteAccount(data: $data) {
        documentId
    }
}`